import { strings } from 'constants/index';

export class CancelError extends Error {
  constructor(message = strings.Api.Cancelled) {
    super(message);
  }
}
